import { SESSION_STORAGE_KEYS } from '@/lib/local-storage-keys'

export function rememberEnvelopeAfterLogin(envelopeId: string): void {
  try {
    window.sessionStorage.setItem(
      SESSION_STORAGE_KEYS.LOGIN_RETURN_ENVELOPE,
      envelopeId,
    )
  } catch {}
}

export function takeEnvelopeAfterLogin(): string | null {
  try {
    const envelopeId = window.sessionStorage.getItem(
      SESSION_STORAGE_KEYS.LOGIN_RETURN_ENVELOPE,
    )
    window.sessionStorage.removeItem(SESSION_STORAGE_KEYS.LOGIN_RETURN_ENVELOPE)
    return envelopeId || null
  } catch {
    return null
  }
}

const isInAppPath = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//')

export function rememberPathAfterLogin(path: string): void {
  if (!isInAppPath(path)) return
  try {
    window.sessionStorage.setItem(SESSION_STORAGE_KEYS.LOGIN_RETURN_PATH, path)
  } catch {}
}

export function takePathAfterLogin(): string | null {
  try {
    const path = window.sessionStorage.getItem(
      SESSION_STORAGE_KEYS.LOGIN_RETURN_PATH,
    )
    window.sessionStorage.removeItem(SESSION_STORAGE_KEYS.LOGIN_RETURN_PATH)
    return path && isInAppPath(path) ? path : null
  } catch {
    return null
  }
}
